import React, { useState } from "react";
import Carousel from "../components/Carousel";
import { useAuth } from "../utilities/AuthContext";
import "../components/home.css";
import { BASE_URL } from "../utilities/api_routes.js";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

const toastOptions = {
  position: "bottom-right",
  autoClose: 8000,
  pauseOnHover: true,
  draggable: true,
  theme: "dark",
};

let errorMsg = "";
const notifySuccess = (message) => {
  toast.success(message, toastOptions);
};

function Home() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  
  const { currentUser } = useAuth();
  // console.log(currentUser);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      errorMsg = "Email is required";
      toast.error(errorMsg, toastOptions);
      return;
    }
    if (name === "") {
      errorMsg = "Name is required";
      toast.error(errorMsg, toastOptions);
      return;
    }
    if (phone === "") {
      errorMsg = "Phone Number is required";
      toast.error(errorMsg, toastOptions);
      return;
    }
    if (message === "") {
      errorMsg = "Message is required";
      toast.error(errorMsg, toastOptions);
      return;
    }
    // if (!isEmailValid(email)) {
    //   errorMsg = "Invalid email address.";
    //   toast.error(errorMsg, toastOptions);
    //   return;
    // }
  
    try {
      const data = {
        name: name,
        email: email,
        phone: phone,
        message: message,
      };
  
      // console.log(data);
      const response = await fetch(`${BASE_URL}/contact`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log(response);
  
      if (response.status !== 200) {
        toast.error("Failed to send your Message", toastOptions);
        return;
      } else {
        notifySuccess(
          "Your Message has been delivered."
        );
      }
    } catch {
      toast.error("Failed to Contact", toastOptions);
    }
  };

  return (
    <div className="hero_area">
      {/* <header className="header_section">
        <div className="container-fluid">
        </div>
      </header> */}
      {/* IDK why this was kept here but it didn't seem like it was needed */}

      <section className="slider_section ">
        <div id="customCarousel1" className="carousel" data-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="container ">
                <div className="row">
                  <div className="col-md-5">
                    <div className="detail-box">
                      <p id="fontsize" className="leading-none">
                        <b> Poster Generator </b>
                        <br />
                        <p className="mt-4">Turns text into posters</p>
                      </p>
                      <p id="fontsize2" className="my-4">
                        Turn your simple prompts into amazing posters in seconds{" "}
                      </p>
                      <div className="btn-box">
                        <Link to="/prompt" className="btn-1">
                          Start Generating
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="row">
                      <div className=" col-lg-10 mx-auto">
                        <div className="img-box">
                          <img
                            className="newclass home-img"
                            src="images/home-5.png"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="gallery_sectionmt-4">
        <h2 className="text-4xl font-bold pt-4 ">Gallery</h2>
        <p className="text-xl font-thin p-4 ">
          Some of our most liked posters.
        </p>
        <Carousel />
      </section>

      <section className="service_section layout_padding">
        {/* <div className="container">
          <div className="heading_container heading_center">
          </div>
        </div> */}
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-4 mb-2">
              <div className="box myclass2 h-full rounded-xl">
                <div className="img-box colorclass">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="currentColor"
                    className="bi bi-laptop"
                    viewBox="0 0 16 16"
                  >
                    <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z" />
                  </svg>
                </div>
                <div className="detail-box myclass2">
                  <h4 className="colour">For Developers</h4>
                  <p className="colour">
                    Give your journey a kickstart by easily creating posters for
                    your products
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-2">
              <div className="box myclass2 h-full rounded-xl">
                <div className="img-box colorclass">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="currentColor"
                    className="bi bi-brush"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.067 6.067 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.118 8.118 0 0 1-3.078.132 3.659 3.659 0 0 1-.562-.135 1.382 1.382 0 0 1-.466-.247.714.714 0 0 1-.204-.288.622.622 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896.126.007.243.025.348.048.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04zM4.705 11.912a1.23 1.23 0 0 0-.419-.1c-.246-.013-.573.05-.879.479-.197.275-.355.532-.5.777l-.105.177c-.106.181-.213.362-.32.528a3.39 3.39 0 0 1-.76.861c.69.112 1.736.111 2.657-.12.559-.139.843-.569.993-1.06a3.122 3.122 0 0 0 .126-.75l-.793-.792zm1.44.026c.12-.04.277-.1.458-.183a5.068 5.068 0 0 0 1.535-1.1c1.9-1.996 4.412-5.57 6.052-8.631-2.59 1.927-5.566 4.66-7.302 6.792-.442.543-.795 1.243-1.042 1.826-.121.288-.214.54-.275.72v.001l.575.575zm-4.973 3.04.007-.005a.031.031 0 0 1-.007.004zm3.582-3.043.002.001h-.002z" />
                  </svg>
                </div>
                <div className="detail-box myclass2">
                  <h4 className="colour">For artists</h4>
                  <p className="colour">
                    Create posters in seconds by just writing few words
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-2">
              <div className="box myclass2 h-full rounded-xl">
                <div className="img-box colorclass">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="currentColor"
                    className="bi bi-briefcase"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z" />
                  </svg>
                </div>
                <div className="detail-box myclass2">
                  <h4 className="colour">For businesses</h4>
                  <p className="colour">
                    Create posters for your products and services
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="box">
          <div className="box3 mb-2">
            <p>
              <b>Contact Us</b>
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mainbox">
              <div className="box4">
                <input 
                  type="text" 
                  className="box5" 
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="box4">
                <input 
                  type="email" 
                  className="box5" 
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="box4">
                <input 
                  type="text" 
                  className="box5" 
                  placeholder="Phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)} 
                />
              </div>
              <div className="box4">
                <input
                  type="text"
                  className="message-box box5"
                  placeholder="Message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
            </div>
            <div className="btn_box ">
              <button className="bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded">
                Send Message
              </button>
            </div>
          </form>
        </div>
        <div className="image">
          <img src="images/contact.png" alt="Left Image" width="100%" />
        </div>
      </div>
    </div>
  );
}

export default Home;
